﻿export class RefreshRequested {
    static eventName() { return 'RefreshRequested'; }

    eventName = RefreshRequested.eventName;

    constructor(public done: () => void) { }
}